import Vue from 'vue'
import Vuex from '@node_modules/vuex'

Vue.use(Vuex);

Vue.config.devtools = true

// Import actions and mutations
import actions from './actions'
import mutations from './mutations'

// Import modules
import sdgDetail from './sdg_detail'

export default new Vuex.Store({
  state: { // rootState in modules
    api: {},
    apiKeys: {},
    assetsRoot: ''
  },
  actions,
  mutations,
  modules: {
    sdgDetail
  }
})